import { createFileRoute } from '@tanstack/react-router'
import { competitionScopesQueryOptions } from '~/features/competition-scopes/query-options'
import { OpportunityRadarPage } from '~/features/opportunity-radar/components'
import { radarEventsInfiniteQueryOptions } from '~/features/opportunity-radar/query-options'
import { parseRadarSearch } from '~/features/opportunity-radar/search-schema'
import { seo } from '~/utils/seo'

export const Route = createFileRoute('/radar/')({
  validateSearch: parseRadarSearch,
  head: () =>
    seo({
      title: 'BallPeek - Match data, team history, and market movement',
      description: 'View match schedules, scores, team history, reference odds, and market movement in one place. BallPeek provides context, not betting advice or recommendations.',
      pathname: '/radar',
    }),
  loaderDeps: ({ search }) => ({
    competitionCode: search.competitionCode,
    season: search.season,
  }),
  loader: async ({ context, deps }) => {
    await Promise.all([
      context.queryClient.prefetchQuery(competitionScopesQueryOptions()),
      context.queryClient.prefetchInfiniteQuery(radarEventsInfiniteQueryOptions({
        tab: 'matches',
        pageSize: 20,
        competitionCode: deps.competitionCode,
        season: deps.season,
      })),
    ])
  },
  component: OpportunityRadarPage,
})
